import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Badge, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { t } from "i18next";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { User } from "@beeldit/user-and-access/users/models/User";
import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";

interface MenuItem {
  label: string;
  to: string;
  children?: MenuItem[];
  icon?: any;
  roles?: string[];
  children_component?: any;
}

interface SidebarProps {
  items: MenuItem[];
}

const logo = process.env.REACT_APP_LOGO_NAME;

function createMenuItem(item: MenuItem, user: User, key?: string) {
  if (item.children) {
    if (item.roles && !item.roles.includes(user.role)) return null;
    return (
      <div key={key}>
        <NavDropdown title={item.label} key={key} id={""}>
          {item.children.map((item: MenuItem, key2: any) => {
            let auxKey = key + "-" + key2;
            return createMenuItem(item, user, auxKey);
          })}
        </NavDropdown>
      </div>
    );
  }

  if (item.roles && !item.roles.includes(user.role)) return null;
  return (
    <Nav.Item key={key}>
      <NavLink to={item.to} className="nav-link hover-translate text-black">
        {item.icon} {item.label} {item.children_component}
      </NavLink>
    </Nav.Item>
  );
}

function Sidebar(props: SidebarProps) {
  const { user } = useContext(AuthContext);

  const { items } = props;

  const { setCommerceId, tenant } = useContext(TenantAndCommerceContext);

  const logoLink = () => {
    if (user?.role === "admin") {
      return "/panel/1/1/dashboard";
    } else if (user?.role === "producer") {
      return "/panel/1/1/producer/orders";
    } else {
      return "/panel";
    }
  };

  return (
    <Nav className="flex-column sidebar d-none d-lg-block p-3">
      <Navbar.Brand key="brand" href={logoLink()}>
        <img src={logo} alt="Andanatura" className="sidebar-logo" />
      </Navbar.Brand>
      {items.map((item: MenuItem, key: any) => {
        if (!user) return null;
        return createMenuItem(item, user, key);
      })}
      <Nav.Item key="logout" className="border-top bottom">
        <a
          onClick={() => {
            setCommerceId(null);
          }}
          href="/login"
          className="nav-link hover-translate text-black-50"
        >
          {t("logout")}
        </a>
      </Nav.Item>
    </Nav>
  );
}

export default Sidebar;
